import { keyframes, style } from '@vanilla-extract/css'
import { vars } from '~/styles/theme.css'

export const wrapper = style({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  boxSizing: 'border-box',
  padding: '1rem',
  gap: '1.5rem',
  margin: 'auto',
  flex: 1
})

export const wrapperSmall = style({
  flexDirection: 'row',
  gap: '0.5rem',
  padding: '0.5rem'
})

export const picto = style({
  maxWidth: 120
})

export const pictoSmall = style({
  width: 30
})

const ellipsis = keyframes({
  to: { width: '1.25em' }
})

export const loaderText = style({
  fontSize: vars.font.headerTitle.size,
  fontWeight: vars.font.headerTitle.weight,
  color: vars.color.dark,
  marginLeft: '1rem',
  position: 'relative',
  marginRight: '1.25em',
  whiteSpace: 'nowrap',

  '::after': {
    position: 'absolute',
    left: '100%',
    overflow: 'hidden',
    display: 'inline-block',
    verticalAlign: 'bottom',
    paddingLeft: '0.15em',
    content: '\\2026',
    animation: `${ellipsis} 1s infinite steps(5, end) 2s`,
    width: 0
  },

  selectors: {
    [`${wrapperSmall} &`]: {
      fontSize: vars.font.body.size,
      fontWeight: vars.font.body.weight,
      color: vars.color.dark
    }
  }
})
